import styled from "styled-components";

export const Container = styled.div`
 
`;

export const Img = styled.img`
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;
